import { Nav, Footer } from "@/components/Nav";
import { useLang } from "@/i18n/LanguageContext";

const H = ({ children }) => <h2 className="font-display text-2xl uppercase">{children}</h2>;
const P = ({ html }) => <p dangerouslySetInnerHTML={{ __html: html }} />;

export default function Termini() {
    const { t, lang } = useLang();
    const locale = lang === "en" ? "en-GB" : "it-IT";
    return (
        <div className="min-h-screen bg-[#15181C] text-[#F4F2ED]">
            <Nav />
            <div className="max-w-3xl mx-auto px-5 md:px-8 py-10">
                <div className="text-xs uppercase tracking-[0.3em] text-[#9AA2AD] mb-2">{t("termini.docLabel")}</div>
                <h1 className="font-display text-5xl md:text-6xl uppercase mb-8">{t("termini.title1")}<br /><span className="text-[#E2231A]">{t("termini.title2")}</span></h1>
                <div className="space-y-6 text-sm leading-relaxed">
                    <p className="text-[#9AA2AD]"><em>{t("termini.lastUpdate")}: {new Date().toLocaleDateString(locale)}</em></p>

                    <H>{t("termini.h1")}</H>
                    <P html={t("termini.p1")} />

                    <H>{t("termini.h2")}</H>
                    <P html={t("termini.p2Intro")} />
                    <ul className="list-disc pl-6 space-y-1">
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p2li1") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p2li2") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p2li3") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p2li4") }} />
                    </ul>
                    <div data-testid="art2-safety-clause" className="border-l-2 border-[#E2231A] bg-[#E2231A]/5 px-4 py-3">
                        <P html={t("termini.p2Extra")} />
                    </div>

                    <H>{t("termini.h3")}</H>
                    <P html={t("termini.p3Intro")} />
                    <ul className="list-disc pl-6 space-y-1">
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p3li1") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p3li2") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p3li3") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p3li4") }} />
                    </ul>

                    <H>{t("termini.h4")}</H>
                    <P html={t("termini.p4")} />

                    <H>{t("termini.h5")}</H>
                    <P html={t("termini.p5")} />

                    <H>{t("termini.h6")}</H>
                    <P html={t("termini.p6Intro")} />
                    <ul className="list-disc pl-6 space-y-1">
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p6li1") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p6li2") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p6li3") }} />
                        <li dangerouslySetInnerHTML={{ __html: t("termini.p6li4") }} />
                    </ul>
                    <P html={t("termini.p6Out")} />

                    <H>{t("termini.h7")}</H>
                    <P html={t("termini.p7")} />

                    <H>{t("termini.h8")}</H>
                    <P html={t("termini.p8")} />
                    <div data-testid="art8-safety-clause" className="border-l-2 border-[#E2231A] bg-[#E2231A]/5 px-4 py-3">
                        <P html={t("termini.p8Extra")} />
                    </div>
                    <div data-testid="art8-damage-clause" className="border-l-2 border-[#9AA2AD]/40 bg-[#1C2026] px-4 py-3">
                        <P html={t("termini.p8Damage")} />
                    </div>

                    <H>{t("termini.h9")}</H>
                    <P html={t("termini.p9")} />

                    <H>{t("termini.h10")}</H>
                    <P html={t("termini.p10")} />

                    <H>{t("termini.h11")}</H>
                    <P html={t("termini.p11")} />

                    <H>{t("termini.h12")}</H>
                    <P html={t("termini.p12")} />
                </div>
            </div>
            <Footer />
        </div>
    );
}
